import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { ReminderSettings } from '../components/student/ReminderSettings';
import { LinkedParentsSettings } from '../components/student/LinkedParentsSettings';

export const StudentSettingsPage: React.FC = () => {
  const { deleteAccount } = useAuth();
  const navigate = useNavigate();
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [deleteText, setDeleteText] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDeleteAccount = async () => {
    setIsDeleting(true);
    try {
      await deleteAccount();
      navigate('/login', { replace: true });
    } catch {
      setIsDeleting(false);
    }
  };

  return (
    <div className="student-settings-page">
      <h1>Settings</h1>
      <ReminderSettings />
      <LinkedParentsSettings />

      <div className="settings-danger-zone">
        <h2>Danger Zone</h2>
        {!showDeleteConfirm ? (
          <button
            className="delete-account-btn"
            onClick={() => setShowDeleteConfirm(true)}
          >
            Delete Account
          </button>
        ) : (
          <div className="delete-confirm-box">
            <p>This will permanently delete your account and all your learning data. This cannot be undone.</p>
            <p>Type <strong>DELETE</strong> to confirm:</p>
            <input
              type="text"
              value={deleteText}
              onChange={(e) => setDeleteText(e.target.value)}
              placeholder="Type DELETE"
              disabled={isDeleting}
            />
            <div className="delete-confirm-actions">
              <button
                className="cancel-btn"
                onClick={() => { setShowDeleteConfirm(false); setDeleteText(''); }}
                disabled={isDeleting}
              >
                Cancel
              </button>
              <button
                className="confirm-delete-btn"
                onClick={handleDeleteAccount}
                disabled={deleteText !== 'DELETE' || isDeleting}
              >
                {isDeleting ? 'Deleting...' : 'Permanently Delete'}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
